// extracted by mini-css-extract-plugin
export default {"tooltip":"RV-z","arrow":"SV-z"};